import React      from "react";
import List       from "../components/list";
import ListItem   from "../components/list-item";
import Service    from "../components/service";
import Spinner    from "../components/spinner";
import View       from "./view";
import messages   from "../../../messages";
import config     from "../../../config";
import ClearIcon            from "material-ui/svg-icons/content/clear";
import IconButton           from "material-ui/IconButton";
import TextField            from "material-ui/TextField";
import SearchIcon           from "material-ui/svg-icons/action/search";
import "../../SearchBox.css";

export default class ServiceView extends View {
    static get title () {
        return "выберите услугу";
    }

    static get titleShort() {
        return "услуга";
    }

    static get defaultProps() {
        return Object.assign({}, super.defaultProps, {
            doctor: null,
        });
    }

    static get propTypes() {
        return Object.assign({}, super.propTypes, {
            clinic: React.PropTypes.number,
            doctor: React.PropTypes.string,
        });
    }

    static get contextTypes() {
        return {
            muiTheme: React.PropTypes.object,
        };
    }

    constructor (props) {
        super(props);

        this.state = Object.assign({}, this.state, {
            items: null,
            visibleItems: null,
            term: "",
        });
        this._isMounted = false;
    }

    fetchData() {
        this.hideErrorMessage();
        this.setState({
            item: null,
            visibleItems: null,
        });
        const doctor = this.props.doctor === null ? "0" : this.props.doctor.toString();
        const clinic = this.props.clinic;
        const tag = this.props.tag === null ? "0" : this.props.tag;

        const url = `${config.dataUrl}api.php?function=services`  +
            `&clinic=${clinic}` +
            `&tag=${tag}` +
            `&doctor=${doctor}`;

        fetch(url).then((response) => {
            return response.json();
        }).then((responseJson) => {
            if (this._isMounted === true) {
                if (responseJson.status === true) {
                    // const sorted = responseJson.services.sort(
                    //     (a,b) => a.name.localeCompare(b.name));
                    this.setState({
                        items: responseJson.services,
                        visibleItems: responseJson.services,
                    });
                } else {
                    this.showErrorMessage(responseJson.description);
                }
            }
        }).catch((error) => {
            if (this._isMounted === true) {
                this.showErrorMessage(messages["REQUEST_FAILED"]);
            }
        });
    }

    componentDidMount() {
        this.fetchData();
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    handleRetryClick() {
        this.fetchData();
    }

    handleSearchFieldChanged = (item, value) => {
        if (!this.state.clearButtonEnabled && value.length > 0) {
            this.setState({ clearButtonEnabled: true });
        }

        if (this.state.clearButtonEnabled && value.length === 0) {
            this.setState({ clearButtonEnabled: false });
        }

        this.getSearchResult(value);

        this.setState({
            term: value
        });
    }
    handleClearButtonTap() {
        this.setState({
            term: ""
        });

        this.getSearchResult("");
    }

    getSearchResult(term) {
        if (term.length === 0){
            this.setState({
                visibleItems: this.state.items,
            });
        }else{
            const termToLower = term.toLowerCase();
            const filtred = this.state.items.filter(item => item.name.toLowerCase().indexOf(termToLower) > -1);
            this.setState({
                visibleItems: filtred,
            });
        }
    }

    renderContent() {
        if (this.state.isErrorMessageVisible === true) {
            return this.renderErrorMessage();
        }

        if (this.state.items === null) {
            return <Spinner />;
        }

        if (this.state.term.length > 0 && this.state.visibleItems.length === 0){
            return <List><ListItem key={this.state.term} isActive={false} >
                Ничего не найдено
            </ListItem></List>
        }

        let nextView = null;
        if (this.props.clinic === null) {
            nextView = "BranchView";
        }else {
            nextView = "DateView";
        }

        const elements = this.state.visibleItems.map((item, key) => {
            return (
                <ListItem key={key} isActive={true} onClick={() => {
                    const props = {
                        service: item.id,
                        openWithoutDoctor: item.openWithoutDoctor,

                    };
                    this.props.gotoNextView({
                        breadcrumbName: item.name.toLowerCase(),
                        nextView: item.openWithoutDoctor ? "DateView" : nextView,
                        props: props
                    });
                }}>
                    <Service name={item.name} price={'от '+item.price} />
                </ListItem>
            );
        });

        return <List>{elements}</List>;
    }

    renderSearchInput() {
        this.colors = this.context.muiTheme.palette;
        return <div className="search-box__container">
            <SearchIcon className="search-box__search-icon"/>

            <TextField
                className="search-box__term"
                fullWidth={true}
                name="searchBoxTerm"
                onChange={this.handleSearchFieldChanged}
                placeholder="найти услугу"
                value={this.state.term}/>

            <IconButton
                className="search-box__clear-button"
                disabled={!this.state.clearButtonEnabled}
                onTouchTap={() => this.handleClearButtonTap()}>
                <ClearIcon
                    color={this.colors.primary3color}
                    hoverColor={this.colors.accent1color}
                />
            </IconButton>
        </div>;
    }

    render() {
        return (
            <div className="appointment-view appointment-view--doctor">
                {/* {!this.props.doctor && this.renderSearchInput()} */}
                {this.renderSearchInput()}
                {this.renderContent()}
            </div>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/widgets/appointment-widget/views/service.js
 **/